const sensors = {
    battery_voltage: String("Tensió de la bateria"),
    soil_1_meter: String("Sonda de sòl de 15cm"),
    soil_2_meter: String("Sonda de sòl de 30cm"),
    soil_3_meter: String("Sonda de sòl de 45cm"),
    leaf_meter: String("Humitat en fulla"),
    hum_meter: String("Humitat Relativa"),
    temp_meter: String("Temperatura"),
    rain_meter: String("Pluviometria"),
    gauge_meter: String("Caudalimetre"),
};

export default sensors;